import { styled } from '@mui/system'
import { Divider as MuiDivider } from '@mui/material'
import { Editor } from '@tiptap/react'
import { StyleType } from '../../../../utils/markdown'
import { UploadedFile } from '../../../../utils/file'
import {
  BlockquoteButton,
  BoldButton,
  CodeBlockButton,
  CodeButton,
  FileButton,
  HeaderFiveButton,
  HeaderFourButton,
  HeaderOneButton,
  HeaderSixButton,
  HeaderThreeButton,
  HeaderTwoButton,
  HorizontalRuleButton,
  ItalicButton,
  OrderedListButton,
  StrikeButton,
  TableButton,
  TaskListButton,
  UnorderedListButton,
} from './StyleButton'

const RootContainer = styled('div')({
  display: 'flex',
  alignItems: 'center',
})
const Divider = styled(MuiDivider)({
  margin: 3,
})
const StyledBlockquoteButton = styled(BlockquoteButton)({ margin: 5 })
const StyledBoldButton = styled(BoldButton)({ margin: 5 })
const StyledCodeBlockButton = styled(CodeBlockButton)({ margin: 5 })
const StyledCodeButton = styled(CodeButton)({ margin: 5 })
const StyledFileButton = styled(FileButton)({ margin: 5 })
const StyledHeaderFiveButton = styled(HeaderFiveButton)({ margin: 5 })
const StyledHeaderFourButton = styled(HeaderFourButton)({ margin: 5 })
const StyledHeaderOneButton = styled(HeaderOneButton)({ margin: 5 })
const StyledHeaderSixButton = styled(HeaderSixButton)({ margin: 5 })
const StyledHeaderThreeButton = styled(HeaderThreeButton)({ margin: 5 })
const StyledHeaderTwoButton = styled(HeaderTwoButton)({ margin: 5 })
const StyledHorizontalRuleButton = styled(HorizontalRuleButton)({ margin: 5 })
const StyledItalicButton = styled(ItalicButton)({ margin: 5 })
const StyledOrderedListButton = styled(OrderedListButton)({ margin: 5 })
const StyledStrikeButton = styled(StrikeButton)({ margin: 5 })
const StyledTableButton = styled(TableButton)({ margin: 5 })
const StyledTaskListButton = styled(TaskListButton)({ margin: 5 })
const StyledUnorderedListButton = styled(UnorderedListButton)({ margin: 5 })

const StyleButtonComponents = (props: {
  editor: Editor | undefined
  disabled?: boolean
  hideHeaderOne?: boolean
  hideHeaderTwo?: boolean
  hideHeaderThree?: boolean
  hideHeaderFour?: boolean
  hideHeaderFive?: boolean
  hideHeaderSix?: boolean
  hideExtras?: boolean
  highlightItems?: string[]
  isInTable?: boolean
  onStyleApply?: (styleType: StyleType) => void
  onTableInsert?: (rows: number, columns: number) => void
  onFileInsert?: (files: UploadedFile[]) => void
}) => {
  const {
    editor,
    disabled,
    hideHeaderOne,
    hideHeaderTwo,
    hideHeaderThree,
    hideHeaderFour,
    hideHeaderFive,
    hideHeaderSix,
    hideExtras,
    highlightItems,
    isInTable,
    onStyleApply,
    onTableInsert,
    onFileInsert,
  } = props
  const buttonProps = {
    editor,
    disabled,
    highlightItems,
    onStyleApply,
    onTableInsert,
    onFileInsert,
  }
  // 表内では Bold・Italic・Strike 以外を無効化する
  const tableRestrictedProps = {
    ...buttonProps,
    disabled: disabled || isInTable,
  }
  return (
    <RootContainer>
      {!hideHeaderOne && <StyledHeaderOneButton {...tableRestrictedProps} />}
      {!hideHeaderTwo && <StyledHeaderTwoButton {...tableRestrictedProps} />}
      {!hideHeaderThree && (
        <StyledHeaderThreeButton {...tableRestrictedProps} />
      )}
      {!hideHeaderFour && <StyledHeaderFourButton {...tableRestrictedProps} />}
      {!hideHeaderFive && <StyledHeaderFiveButton {...tableRestrictedProps} />}
      {!hideHeaderSix && <StyledHeaderSixButton {...tableRestrictedProps} />}
      <Divider orientation="vertical" variant="middle" flexItem={true} />
      <StyledBoldButton {...buttonProps} />
      <StyledItalicButton {...buttonProps} />
      <StyledStrikeButton {...buttonProps} />
      <Divider orientation="vertical" variant="middle" flexItem={true} />
      <StyledCodeButton {...tableRestrictedProps} />
      <StyledCodeBlockButton {...tableRestrictedProps} />
      <Divider orientation="vertical" variant="middle" flexItem={true} />
      <StyledBlockquoteButton {...tableRestrictedProps} />
      <StyledUnorderedListButton {...tableRestrictedProps} />
      <StyledOrderedListButton {...tableRestrictedProps} />
      {!hideExtras && (
        <>
          <Divider orientation="vertical" variant="middle" flexItem={true} />
          <StyledHorizontalRuleButton {...tableRestrictedProps} />
          <StyledTaskListButton {...tableRestrictedProps} />
          <StyledTableButton {...tableRestrictedProps} />
          <StyledFileButton {...tableRestrictedProps} />
          <Divider orientation="vertical" variant="middle" flexItem={true} />
        </>
      )}
    </RootContainer>
  )
}

const RichTextStyleButtons = StyleButtonComponents

export { RichTextStyleButtons }
